import { createConsumer } from '@rails/actioncable';
import { onBeforeUnmount } from 'vue';

const createSharedConsumer = () => {
  const { websocketURL = '' } = window.chatwootConfig || {};
  const cableURL = websocketURL ? `${websocketURL}/cable` : undefined;
  return createConsumer(cableURL);
};

const consumer = createSharedConsumer();

const useBroadcastProgressChannel = () => {
  const subscriptions = new Map();

  const subscribeToBroadcast = (scheduledMessageId, handler) => {
    if (!scheduledMessageId || subscriptions.has(scheduledMessageId)) {
      return;
    }

    const subscription = consumer.subscriptions.create(
      {
        channel: 'BroadcastProgressChannel',
        scheduled_message_id: scheduledMessageId,
      },
      {
        received: data => {
          handler?.(data);
        },
      }
    );

    subscriptions.set(scheduledMessageId, subscription);
  };

  const unsubscribeFromBroadcast = scheduledMessageId => {
    if (!subscriptions.has(scheduledMessageId)) {
      return;
    }
    const subscription = subscriptions.get(scheduledMessageId);
    consumer.subscriptions.remove(subscription);
    subscriptions.delete(scheduledMessageId);
  };

  const resetSubscriptions = () => {
    subscriptions.forEach(subscription => {
      consumer.subscriptions.remove(subscription);
    });
    subscriptions.clear();
  };

  onBeforeUnmount(() => {
    resetSubscriptions();
  });

  return {
    subscribeToBroadcast,
    unsubscribeFromBroadcast,
    resetSubscriptions,
  };
};

export default useBroadcastProgressChannel;
